module.exports = __webpack_public_path__ + "static/img/企业数字业务.b618af6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/企业数字业务.png
// module id = HVOP
// module chunks = 0